// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedPaymentOverrideReason {
  adminMistake: {"enum_constant":"adminMistake"};
  fraudulentBehaviour: {"enum_constant":"fraudulentBehaviour"};
  legacyCancellationWithNotice: {"enum_constant":"legacyCancellationWithNotice"};
  legacyCancellationWithoutNotice: {"enum_constant":"legacyCancellationWithoutNotice"};
  other: {"enum_constant":"other"};
  ruleViolation: {"enum_constant":"ruleViolation"};
  studentIssue: {"enum_constant":"studentIssue"};
  systemIssue: {"enum_constant":"systemIssue"};
  teacherAbsence: {"enum_constant":"teacherAbsence"};
  teacherTechnicalIssue: {"enum_constant":"teacherTechnicalIssue"};
  verifiedTeacherReason: {"enum_constant":"verifiedTeacherReason"};
}

export type PaymentOverrideReasonId = keyof IParsedPaymentOverrideReason;
export type PaymentOverrideReasonData = IParsedPaymentOverrideReason[PaymentOverrideReasonId];
const data: PaymentOverrideReasonData[] = [{"enum_constant":"adminMistake"},{"enum_constant":"fraudulentBehaviour"},{"enum_constant":"legacyCancellationWithNotice"},{"enum_constant":"legacyCancellationWithoutNotice"},{"enum_constant":"other"},{"enum_constant":"ruleViolation"},{"enum_constant":"studentIssue"},{"enum_constant":"systemIssue"},{"enum_constant":"teacherAbsence"},{"enum_constant":"teacherTechnicalIssue"},{"enum_constant":"verifiedTeacherReason"}];
export default data;
